<template>
    <div :class="className" :style="{height:eHeight,width:width}" />
</template>
<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

export default {
    mixins: [resize],
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        eHeight: {
            type: String,
            default: '100%'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        chartData: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler(val) {
                this.setOptions(val)
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart()
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$el, 'macarons')
            // this.setOptions(this.chartData || {})
        },
        setOptions(data) {
            this.chart.setOption({
                legend: {
                    show: false,
                    data: ['计划数', '完成情况']
                },
                tooltip: {
                  backgroundColor:'rgba(255,255,255,1)'
                },
                radar: {
                    // shape: 'circle',
                    indicator: data.radarNmae
                },
                series: [{
                    type: 'radar',
                    data: [{
                            value: data.cntData,
                            name: '计划数',
                            lineStyle: {
                                color: '#1a90ff'
                            },
                            itemStyle: {
                                color: '#1a90ff'
                            }
                        },
                        {
                            value: data.doneCntData,
                            name: '完成情况',
                            lineStyle: {
                                color: '#facc13'
                            },
                            itemStyle: {
                                color: '#facc13'
                            }
                        }
                    ]
                }]
            })
        }
    }
}

</script>
